/** Last four characters of the booking number, used as the boarding PIN and QR payload. */
export function getBookingPin(bookingNumber: string): string {
  const trimmed = bookingNumber.trim();
  if (!trimmed) return "";
  return trimmed.slice(-4);
}
